.panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.header {
  display: flex;
  gap: 8px;
}

/* Two cards side by side on wide screens, stacked on phones. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr));
  gap: var(--space-3);
}

.block {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
}

/* Drop zone: the whole card-sized label is the file picker. */
.drop {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 132px;
  padding: var(--space-4);
  border: 2px dashed var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-bg);
  text-align: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 60ms var(--ease-out), border-color var(--motion-fast) var(--ease-out),
    background var(--motion-fast) var(--ease-out);
}

@media (hover: hover) {
  .drop:hover {
    border-color: var(--color-accent);
    background: var(--color-bg-elevated);
  }
}

.drop:active {
  transform: scale(0.98);
}

.drop:focus-within {
  border-color: var(--color-text);
}

.dropActive {
  border-color: var(--color-accent);
  background: rgba(229, 9, 20, 0.12);
}

.dropBusy {
  opacity: 0.5;
  cursor: progress;
  pointer-events: none;
}

.dropIcon {
  width: 32px;
  height: 32px;
  fill: var(--color-accent-text);
}

.dropTitle {
  font-size: var(--fs-md);
  font-weight: 700;
}

.label {
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.urlRow {
  display: flex;
  gap: var(--space-2);
}

.input {
  flex: 1;
  min-width: 0;
  height: 44px;
  padding: 0 var(--space-3);
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border-strong);
  background: var(--color-bg);
  color: var(--color-text);
  font: inherit;
  font-size: var(--fs-sm);
}

.input:focus {
  outline: none;
  border-color: var(--color-text);
}

.input::placeholder {
  color: var(--color-text-subtle);
}

.progressRow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.bar {
  flex: 1 1 200px;
  height: 6px;
  border-radius: 3px;
  background: var(--color-border);
  overflow: hidden;
}

.fill {
  height: 100%;
  background: var(--color-accent, #e50914);
  transition: width 0.2s ease;
}

.meta {
  font-size: var(--fs-xs, 12px);
  color: var(--color-text-subtle);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border);
}

.row:last-child {
  border-bottom: none;
}

.info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--fs-sm, 14px);
}

.error {
  font-size: var(--fs-xs, 12px);
  color: var(--color-error);
}
